function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#orbis-logo_svg__clip0)",
  fill: "#464D53"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M73.993 23.623h-3.595V9.293H82.3l.903.09a4.474 4.474 0 012.777 6.93l-.11.125.204.196a3.91 3.91 0 01.876 2.499 4.486 4.486 0 01-3.575 4.388l-.895.09-8.487.012zm8.506-3.579l.344-.074a.896.896 0 00-.348-1.725h-8.502v1.795l8.506.004zm-.184-5.37a.896.896 0 00.348-1.72l-.348-.067h-8.322v1.791l8.322-.004z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M91.893 9.3H88.32v14.323h3.574V9.3z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M93.689 23.623v-3.579h11.631a.899.899 0 000-1.795h-7.607a4.474 4.474 0 010-8.945h11.189v3.583H97.713a.9.9 0 000 1.799h7.607a4.473 4.473 0 110 8.944H93.689v-.007zM64.532 23.619l-8.96-8.94h9.022l.349-.071a.907.907 0 00.547-.83.891.891 0 00-.895-.887h-10.81l-3.58-3.575h14.393l.458.024a4.474 4.474 0 01-.458 8.925h-.39l5.37 5.37-5.046-.016zM53.343 15.331l-2.511 2.511-8.57-8.561h5.065l6.016 6.05z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.428 23.623a7.161 7.161 0 010-14.323h1.83l3.59 3.59h-5.42a3.579 3.579 0 000 7.154h6.708a3.57 3.57 0 002.534-1.056l3.669-3.665 2.526 2.523-3.66 3.665a7.153 7.153 0 01-4.334 2.065l-.727.035-6.716.012zM13.724 27.448h-.035l-5.476-5.476H2.738l-.266-.356a13.724 13.724 0 1122.621-.207l-.438.59-5.413-5.44a4.846 4.846 0 10-6.852 6.856l3.802 3.806-1.06.156c-.466.047-.931.067-1.408.067v.004zm6.535-1.635c.391-.211.782-.442 1.134-.689l.52-.39-5.412-5.433a.97.97 0 10-1.37 1.373l5.128 5.139z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "orbis-logo_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h109.798v32H0z"
})));

function SvgOrbisLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 32,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgOrbisLogo;